import React, { PropsWithChildren } from 'react'
import { useAppSelector } from '../../hooks'
import {
  Env,
  UiCodeLimitQty,
  UiCodePIM,
  UiCodePricesOmnichannel,
  UiCodeSettings,
  UiCodeUtility,
} from '../../Constants/Configuration'
import { isProdSite } from '../../Helpers/GenericHelpers'

interface RenderProfileOption {
  excludeByEnv?: Env
  sectionName?: string
}

const RenderByProfileOptionWrapper: React.FunctionComponent<PropsWithChildren<RenderProfileOption>> = props => {
  const { excludeByEnv, sectionName, children } = props
  const isOmnichannelAndPricesVisibile = useAppSelector(
    state => state.present.configuration.isOmnichannelAndPricesVisibile,
  )
  const isImagesVisible = useAppSelector(state => state.present.configuration.isImagesVisible)
  const isSettingsVisible = useAppSelector(state => state.present.configuration.settingsVisibility)

  const islimitQtyVisible = useAppSelector(state => state.present.configuration.limitQtyModule)

  let visible = false //default not show
  let env = true

  if (sectionName) {
    switch (sectionName) {
      case UiCodePricesOmnichannel:
        visible = isOmnichannelAndPricesVisibile
        break
      case UiCodePIM:
        visible = isImagesVisible
        break
      case UiCodeSettings:
        visible = isSettingsVisible
        break
      case UiCodeLimitQty:
        visible = isOmnichannelAndPricesVisibile && islimitQtyVisible
        break
      case UiCodeUtility:
        visible = true
        break
      default:
        break
    }
  }

  if (excludeByEnv && excludeByEnv === Env.Prod) {
    env = !isProdSite()
  }

  //https://stackoverflow.com/questions/67908439/react-typescript-how-to-fix-return-type-element-is-not-a-valid-jsx-eleme
  //react fragment prevent React children type issues
  return env && visible ? <>{children}</> : null
}

export default RenderByProfileOptionWrapper
